import script from "./WaterModalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./WaterModalContent.vue?vue&type=script&setup=true&lang=js"

import "./WaterModalContent.vue?vue&type=style&index=0&id=66bba47c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66bba47c"]])

export default __exports__